import type { RouteRecordRaw } from "vue-router";

export const routes = <RouteRecordRaw[]>[
  {
    path: "/p",
    name: "public",
    component: () => import("@web/features/Public/PublicContainer.vue"),
    redirect: () => {
      return {
        name: "login",
      };
    },
    meta: {
      skipAuthChecks: true,
    },
    children: [
      {
        path: "report/:hash",
        name: "public-report-overview",
        component: () => import("@web/features/Public/Report/PublicReportOverview.vue"),
        meta: {
          skipAuthChecks: true,
          public: true,
          hideNavbar: true,
          hasHeader: true,
        },
      },
      {
        path: "report/:hash/not-configured",
        name: "public-report-not-configured",
        component: () => import("@web/features/Public/Report/PublicReportNotConfigured.vue"),
        meta: {
          skipAuthChecks: true,
          public: true,
          hideNavbar: true,
          hasHeader: true,
        },
      },
      {
        path: "report/:hash/create",
        name: "public-report-create",
        component: () => import("@web/features/Public/Report/PublicReportCreate.vue"),
        meta: {
          skipAuthChecks: true,
          back: true,
          public: true,
          hideNavbar: true,
          hasHeader: true,
        },
      },
      {
        path: "report/:hash/view/:reportId",
        name: "public-report-view",
        component: () => import("@web/features/Public/Report/PublicReportView.vue"),
        meta: {
          skipAuthChecks: true,
          public: true,
          back: true,
          hideNavbar: true,
          hasHeader: true,
        },
      },
      {
        path: "report/:hash/sent/:reportId",
        name: "public-report-sent",
        component: () => import("@web/features/Public/Report/PublicReportSent.vue"),
        meta: {
          skipAuthChecks: true,
          public: true,
          back: true,
          hideNavbar: true,
          hasHeader: true,
        },
      },
    ],
  },
  {
    // Self-contained public quote view: an anonymous recipient opens a shared price quote here.
    // Not nested under the report container above, which provides its own report-specific store/chrome.
    path: "/p/quote/:token",
    name: "public-quote",
    component: () => import("@web/features/Public/Quote/PublicQuoteView.vue"),
    meta: {
      skipAuthChecks: true,
      public: true,
      hideNavbar: true,
    },
  },
];

export default routes;
